/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_DownloadInputs */

const cs_tasks_protocol_download = /** @type {(inputs: Tasks_Protocol_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout PDF`)
};

const en_tasks_protocol_download = /** @type {(inputs: Tasks_Protocol_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PDF`)
};

/**
* | output |
* | --- |
* | "Download PDF" |
*
* @param {Tasks_Protocol_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_download = /** @type {((inputs?: Tasks_Protocol_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_download(inputs)
	return cs_tasks_protocol_download(inputs)
});